import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/compound/payment-plans";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/compound/dropdown/PaymentPlan?status=1";
const apiTogglle=API_BASE_URL_ENV() + "/admin/compound/toggle-activation/PaymentPlan"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getDropDown=(id, data)=>{
        if(data){
            return  http.get(`${apiDropDownEndpoint}&compound_ids=${id}`, data) 
        }
        return  http.get(`${apiDropDownEndpoint}&compound_ids=${id}`) 
    }
    toggleStatus(id) {
        return http.get(`${apiTogglle}/${id}`);
      }
 }